import Service, { getCallApiFunction } from '../service'

interface INotificationListParams {
  pageSize: number
  pageNo: number
}

class FetchNotificationListApi extends Service {
  constructor(params: INotificationListParams) {
    super()
    this.name = 'FETCH_NOTIFICATION_LIST'

    this.config = {
      url: `/v1/notification/list`,
      method: 'GET',
      params,
    }
  }
}

export const fetchNotificationList = (params: INotificationListParams) => getCallApiFunction(new FetchNotificationListApi(params))
